import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import KOLShowcase from "@/components/KOLShowcase";
import Testimonials from "@/components/Testimonials";
import HowWeWork from "@/components/HowWeWork";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

/**
 * 页面板块顺序（逻辑链）：
 * 1. Hero        — 品牌口号，第一印象
 * 2. About       — 公司介绍 + 核心数据 + 平台覆盖 + 我们的优势
 * 3. Services    — 服务体系（四大服务）
 * 4. KOLShowcase — KOL资源展示（证明能力）
 * 5. Testimonials— 合作案例 + 客户评价（建立信任）
 * 6. HowWeWork   — 合作流程（降低决策门槛）
 * 7. Contact     — 联系我们（行动召唤）
 * 8. Footer      — 页脚
 */
export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <KOLShowcase />
      <Testimonials />
      <HowWeWork />
      <Contact />
      <Footer />
    </div>
  );
}